import { create } from "zustand";
import { persist } from "zustand/middleware";

interface PanelState {
  indicatorsOpen: boolean;

  openIndicators: () => void;
  closeIndicators: () => void;
  toggleIndicators: () => void;
  closeAllPanels: () => void;
}

export const useDesktopPanelStore = create<PanelState>()(
  persist(
    (set) => ({
      indicatorsOpen: false,

      openIndicators: () => set({ indicatorsOpen: true }),
      closeIndicators: () => set({ indicatorsOpen: false }),
      toggleIndicators: () =>
        set((state) => ({ indicatorsOpen: !state.indicatorsOpen })),

      closeAllPanels: () => set({ indicatorsOpen: false }),
    }),
    {
      name: "lytick-panel-state",
      version: 2,
      migrate: () => ({ indicatorsOpen: false }),
    },
  ),
);
